import * as React from 'react';

import { L10n } from '../../../../ts/L10n/L10n';
import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';

export interface Timestamp {
  label: string;
  value: Date;
}

export function Timestamp(props: Timestamp) {
  return (
    <div className={DetailsTooltipStyles.MetadataSection}>
      <span className={DetailsTooltipStyles.MetadataTitle}>{ props.label }</span>
      <span className={DetailsTooltipStyles.MetadataValue}>{ L10n.localizedDateTime(props.value) }</span>
    </div>
  );
}

